import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';

export const StyledTabButtonContainer = styled.div`
  position: relative;
`;

export const StyledTabButton = styled.button`
  display: flex;
  gap: ${key('sizes.gap.tiny', '5px')};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${palette('background', 2)};
  color: ${palette('text', 0)};
  border: none;
  border-radius: ${key('sizes.borderRadius.tiny', '10px')};
  padding: 5px 20px;
  height: 100%;
`;

export const Menu = styled.ul`
  display: ${(props) => (props.isOpened ? 'grid' : 'none')};
  list-style: none;
  margin: 0;
  background: ${palette('background', 0)};
  color: ${palette('text', 1)};
  position: absolute;
  border: 1px solid ${palette('border', 0)};
  border-radius: 5px;
  opacity: 1;
  position: absolute;
  ${(props) => css`
    width: ${props?.dropDownWidth};
  `}
  top: 40px;
  right: 0px;
  box-sizing: border-box;
  padding: 0;
  justify-items: flex-start;
  gap: 5px;
  z-index: 10;
  max-height: 230px;
  overflow-y: auto;
`;

export const MenuItem = styled.li`
  padding: 5px 0;
  display: flex;
  gap: 10px;
  justify-items: center;
  align-items: center;
  color: ${palette('text', 0)};
  svg {
    vertical-align: middle;
  }
  padding: 15px 15px;
  width: 100%;
  box-sizing: border-box;
  text-align: initial;
`;
